module.exports = __webpack_public_path__ + "static/QuoteVersions-19460ed431fa07ecfadf8888feabc9b4.png";